var React = require('react');

function HeroTransition (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 38.3531V189.5H1440V0C1339.6 31.9038 909 267.291 572 126.469C235 -14.3531 151.439 6.44926 0 38.3531Z","fill":"white"}));
}

HeroTransition.defaultProps = {"width":"1440","height":"187","viewBox":"0 0 1440 187","fill":"none"};

module.exports = HeroTransition;

HeroTransition.default = HeroTransition;
